const theme = {
  loaded: true,
  unit: "px",
  base: "",

  fontSize: {
    heading1: 26,
    heading2: 20,
    heading3: 18,
    heading4: 14,
    text1: 16,
    text2: 15,
    text3: 14,
    text4: 12,
  },
  color: {
    blue: "#1655B9",
    mainBlue: "#0063FF",
    white: "#FFFFFF",
    gray: "#AFB4B1",
    orang: "#E60012",
    lightGray: "#C1C1C1",
    input: "#F1F1F1",
    lightgreen: "#63D09C",
    error: "#F30001",
    dark: "#3B67AD",
    text: "#293041",
    label: "#4A69A6",
    border: "#29445f",
    background: "#FBFCFC",
    lightText: "#DADADA",
    line: "#D8D8D8",
    stroke: "#E1E1E1",
    mainOrange: "#FF5A34",
    darkGray: "#57689F"
  },
  space(...args) {
    const result = (args.length ? [...args] : [1]).reduce(
      (str, curr) => `${str} ${curr}px`,
      ""
    );
    return result;
  },
  css: {
    borderRadius: "8px;",
    centered:
      "position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);",
    transition: "all 300ms ease-in-out;",
    boxShadow: "0px 4px 6px -2px rgba(0,0,0,0.5);",
  },
};

export default theme;
